<template>
    <div>
        <form @submit.prevent="filterTable">
            <div class="row">
                <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="loan-re-date">Start Date</label>
                    <b-form-group id="loan-re-date" label-for="loan-re-date">
                        <b-form-input class="mt-2 field-container fields" type="date"
                            v-model="form.start_date"></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="loan-re-date">End Date</label>
                    <b-form-group id="loan-re-date" label-for="loan-re-date">
                        <b-form-input class="mt-2 field-container fields" type="date"
                            v-model="form.end_date"></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="branch">Branch</label>
                    <multiselect class="mt-2 field-container" v-model="form.branch" :options="form.branch_option"
                        track-by="name" placeholder="Select one" selectLabel="" deselectLabel="" label="name">
                    </multiselect>
                </div>
                <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="acc_types">Account type </label>
                    <multiselect :multiple="true" class="mt-2 field-container" v-model="form.acc_types"
                        :options="form.acc_types_option" track-by="name" placeholder="Select Product"
                        :limit-text="limitText" :limit="1" selectLabel="" deselectLabel="" label="name">
                    </multiselect>
                </div>
            </div>
        </form>
    </div>

</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: {
        Multiselect
    },
    props: ['form', 'filterTable'],
    data() {
        return {
            status_options: ['Cash', 'Cheque'],
            more_details: false,

        }
    },
    methods: {
        show_more() {
            this.more_details = !this.more_details
        },
        limitText(count) {
            return `and ${count} other product(s)`;
        },

    }
}

</script>